import { Link, createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { q } from '../../api/queries';
import { Pager } from '../../components/pager';
import { freshnessOf } from '../../lib/format';
import { Empty, Mono, Page, PageHeader, Panel, Skeleton, Table, col } from '@bounded/ui/primitives';
import { ErrorNotice, FreshnessLabel } from '@bounded/ui/state';
import { useFormat, useT } from '../../i18n';

export const Route = createFileRoute('/_app/devices/')({
  validateSearch: (search): { after?: string } => ({ after: typeof search.after === 'string' && search.after ? search.after : undefined }),
  component: Devices,
});

function Devices() {
  const t = useT(); const m = t.devices; const f = useFormat();
  const { after } = Route.useSearch();
  const devices = useQuery(q.devices(after));
  const items = devices.data?.items ?? [];
  return (
    <Page>
      <PageHeader title={m.title} description={m.description} />
      {devices.error ? <ErrorNotice error={devices.error} onRetry={() => void devices.refetch()} /> : (
        <Panel>
          {!devices.data ? <div className="p-4"><Skeleton className="h-40" /></div> : !items.length ? <Empty title={m.empty} /> : (
            <Table head={[{ label: t.labels.name }, { label: m.owner, className: col.hideSm }, { label: m.lastReport }, { label: t.labels.created, className: col.hideMd }]}>
              {items.map((d) => (
                <tr key={d.id}>
                  <td><Link to="/devices/$deviceId" params={{ deviceId: d.id }} className="font-medium hover:underline">{d.name}</Link><div className="text-graphite"><Mono value={d.id} /></div></td>
                  <td className={col.hideSm}><Link to="/accounts/$accountId" params={{ accountId: d.user_id }} className="hover:underline">{d.user_name ?? <Mono value={d.user_id} />}</Link></td>
                  <td><FreshnessLabel freshness={freshnessOf(d.reported_at, d.revoked_at !== null)} at={d.reported_at} /></td>
                  <td className={`${col.hideMd} text-graphite`}>{f.dateTime(d.created_at)}</td>
                </tr>
              ))}
            </Table>
          )}
        </Panel>
      )}
      {devices.data && <Pager to="/devices" after={after} items={items} />}
    </Page>
  );
}
